import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, addDoc } from 'firebase/firestore';
import { db } from '../../firebase/credenciales';
import Swal from 'sweetalert2';
import './Cities.css';

const Cities = () => {
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState('');
    const [stateCity, setStateCity] = useState('');
    const [satteEnero, setSatteEnero] = useState('');
    const [satteFebrero, setSatteFebrero] = useState('');
    const [stateMarzo, setStateMarzo] = useState('');
    const [stateAbril, setStateAbril] = useState('');
    const [stateMayo, setStateMayo] = useState('');
    const [stateJunio, setStateJunio] = useState('');
    const [stateJulio, setStateJulio] = useState('');
    const [stateAgosto, setStateAgosto] = useState('');
    const [stateSeptiembre, setStateSeptiembre] = useState('');
    const [stateOctubre, setStateOctubre] = useState('');
    const [stateNoviembre, setStateNoviembre] = useState('');
    const [stateDiciembre, setStateDiciembre] = useState('');
    const [statePromedio_Anual, setStatePromedio_Anual] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStates = async () => {
            const querySnapshot = await getDocs(collection(db, 'Estados'));
            const statesData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            statesData.sort((a, b) => a.name.localeCompare(b.name));
            setStates(statesData);
        };

        fetchStates();
    }, []);

    const handleWheel = (e) => {
        if (e.target.type === 'number') {
            e.preventDefault();
        }
    };

    useEffect(() => {
        window.addEventListener('wheel', handleWheel, { passive: false });
        return () => {
            window.removeEventListener('wheel', handleWheel);
        };
    }, []);

    const handleAddCity = async (e) => {
        e.preventDefault();

        if (selectedState && stateCity && statePromedio_Anual && satteEnero && satteFebrero && stateMarzo && stateAbril && stateMayo && stateJunio && stateJulio && stateAgosto && stateSeptiembre && stateOctubre && stateNoviembre && stateDiciembre) {
            const newCity = {
                stateId: selectedState,
                city: stateCity,
                Enero: Number(satteEnero),
                Febrero: Number(satteFebrero),
                Marzo: Number(stateMarzo),
                Abril: Number(stateAbril),
                Mayo: Number(stateMayo),
                Junio: Number(stateJunio),
                Julio: Number(stateJulio),
                Agosto: Number(stateAgosto),
                Septiembre: Number(stateSeptiembre),
                Octubre: Number(stateOctubre),
                Noviembre: Number(stateNoviembre),
                Diciembre: Number(stateDiciembre),
                Promedio_Anual: Number(statePromedio_Anual),
            };

            try {
                await addDoc(collection(db, 'Ciudades'), newCity);
                Swal.fire({
                    title: 'Éxito',
                    text: 'Ciudad registrada con éxito.',
                });
                setSelectedState('');
                setStateCity('');
                setSatteEnero('');
                setSatteFebrero('');
                setStateMarzo('');
                setStateAbril('');
                setStateMayo('');
                setStateJunio('');
                setStateJulio('');
                setStateAgosto('');
                setStateSeptiembre('');
                setStateOctubre('');
                setStateNoviembre('');
                setStateDiciembre('');
                setStatePromedio_Anual('');
            } catch (error) {
                console.error('Error al guardar la ciudad en la base de datos:', error);
                Swal.fire({
                    title: 'Error',
                    text: 'Ocurrió un error al guardar la ciudad en la base de datos.',
                });
            }
        } else {
            Swal.fire({
                title: 'Error',
                text: 'Por favor, llena todos los campos.',
            });
        }
    };

    return (
        <div className="states-container">
            <h1 className="states-title">Registrar Ciudades</h1>
            <form className="form-states" onSubmit={handleAddCity}>
                <div className="input-row-states">
                    <label className="label-states">
                        Nombre del estado
                        <select
                            className="input-states"
                            value={selectedState}
                            onChange={(e) => setSelectedState(e.target.value)}
                            required
                        >
                            <option value="">Selecciona un estado</option>
                            {states.map(state => (
                                <option key={state.id} value={state.id}>{state.name}</option>
                            ))}
                        </select>
                    </label>
                    <label className="label-states">
                        Nombre de la ciudad
                        <input
                            className="input-states"
                            type="text"
                            value={stateCity}
                            onChange={(e) => setStateCity(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <div className="input-row-states">
                    <label className="label-states">
                        Enero
                        <input
                            className="input-states"
                            type="number"
                            value={satteEnero}
                            onChange={(e) => setSatteEnero(e.target.value)}
                            required
                        />
                    </label>
                    <label className="label-states">
                        Febrero
                        <input
                            className="input-states"
                            type="number"
                            value={satteFebrero}
                            onChange={(e) => setSatteFebrero(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <div className="input-row-states">
                    <label className="label-states">
                        Marzo
                        <input
                            className="input-states"
                            type="number"
                            value={stateMarzo}
                            onChange={(e) => setStateMarzo(e.target.value)}
                            required
                        />
                    </label>
                    <label className="label-states">
                        Abril
                        <input
                            className="input-states"
                            type="number"
                            value={stateAbril}
                            onChange={(e) => setStateAbril(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <div className="input-row-states">
                    <label className="label-states">
                        Mayo
                        <input
                            className="input-states"
                            type="number"
                            value={stateMayo}
                            onChange={(e) => setStateMayo(e.target.value)}
                            required
                        />
                    </label>
                    <label className="label-states">
                        Junio
                        <input
                            className="input-states"
                            type="number"
                            value={stateJunio}
                            onChange={(e) => setStateJunio(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <div className="input-row-states">
                    <label className="label-states">
                        Julio
                        <input
                            className="input-states"
                            type="number"
                            value={stateJulio}
                            onChange={(e) => setStateJulio(e.target.value)}
                            required
                        />
                    </label>
                    <label className="label-states">
                        Agosto
                        <input
                            className="input-states"
                            type="number"
                            value={stateAgosto}
                            onChange={(e) => setStateAgosto(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <div className="input-row-states">
                    <label className="label-states">
                        Septiembre
                        <input
                            className="input-states"
                            type="number"
                            value={stateSeptiembre}
                            onChange={(e) => setStateSeptiembre(e.target.value)}
                            required
                        />
                    </label>
                    <label className="label-states">
                        Octubre
                        <input
                            className="input-states"
                            type="number"
                            value={stateOctubre}
                            onChange={(e) => setStateOctubre(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <div className="input-row-states">
                    <label className="label-states">
                        Noviembre
                        <input
                            className="input-states"
                            type="number"
                            value={stateNoviembre}
                            onChange={(e) => setStateNoviembre(e.target.value)}
                            required
                        />
                    </label>
                    <label className="label-states">
                        Diciembre
                        <input
                            className="input-states"
                            type="number"
                            value={stateDiciembre}
                            onChange={(e) => setStateDiciembre(e.target.value)}
                            required
                        />
                    </label>
                </div>
                <label className="label-states">
                    Promedio anual
                    <input
                        className="input-states"
                        type="number"
                        value={statePromedio_Anual}
                        onChange={(e) => setStatePromedio_Anual(e.target.value)}
                        required
                    />
                </label>
                <div className="states-btn-container">
                    <button className="btn-sates" type="submit">Agregar ciudad</button>
                    <button className="btn-sates" onClick={() => navigate('/admin/ciudades/settings')}>Cancelar</button>
                </div>
            </form>
        </div>
    );
};

export default Cities;